var _rect, _rect2, _g, _g2, _path, _g3, _g4, _g5, _g6, _g7, _path2, _g8, _g9, _rect3, _rect4, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEnvelop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 98,
    viewBox: "0 0 161 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 145,
    height: 97,
    rx: 8.5,
    transform: "matrix(1 0 0 -1 1 98)",
    fill: "url(#paint0_linear_411_46116)",
    stroke: "url(#paint1_linear_411_46116)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_411_46116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 144,
    height: 96
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 144,
    height: 96,
    rx: 8,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_411_46116)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_411_46116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 97L142 97L81.5551 42.6872C78.5309 39.9698 77.0187 38.611 75.3091 38.0956C73.8032 37.6416 72.1968 37.6416 70.6909 38.0956C68.9813 38.611 67.4691 39.9698 64.4449 42.6872L4 97Z",
    fill: "#334155",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_411_46116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 97L134 97L82.5281 39.6215C79.2296 35.9444 77.5803 34.1059 75.6365 33.4274C73.9294 32.8315 72.0706 32.8315 70.3635 33.4274C68.4197 34.1059 66.7704 35.9444 63.4719 39.6215L12 97Z",
    fill: "#334155",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_411_46116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 97L142 97L82.3617 33.0401C79.1077 29.5502 77.4806 27.8053 75.5783 27.1576C73.9065 26.5885 72.0935 26.5885 70.4217 27.1576C68.5194 27.8053 66.8924 29.5502 63.6383 33.0401L4 97Z",
    fill: "#334155",
    fillOpacity: 0.1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_411_46116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 97L145 97L81.3523 42.1921C78.389 39.6403 76.9073 38.3644 75.2444 37.8784C73.7788 37.45 72.2212 37.45 70.7556 37.8784C69.0927 38.3644 67.611 39.6403 64.6477 42.1921L1 97Z",
    fill: "url(#paint2_linear_411_46116)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 95L64.6546 41.6617C67.616 39.1203 69.0967 37.8496 70.7575 37.3661C72.2211 36.9399 73.7761 36.9408 75.2393 37.3686C76.8994 37.8541 78.3787 39.1264 81.3373 41.6712L144.5 96",
    stroke: "#475569",
    strokeOpacity: 0.06
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_411_46116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1L142 1L81.5551 55.3128C78.5309 58.0302 77.0187 59.389 75.3091 59.9044C73.8032 60.3584 72.1968 60.3584 70.6909 59.9044C68.9813 59.389 67.4691 58.0302 64.4449 55.3128L4 1Z",
    fill: "#334155",
    fillOpacity: 0.4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_411_46116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1L134 1L82.5281 58.3785C79.2296 62.0556 77.5803 63.8941 75.6365 64.5726C73.9294 65.1685 72.0706 65.1685 70.3635 64.5726C68.4197 63.8941 66.7704 62.0556 63.4719 58.3785L12 1Z",
    fill: "#334155",
    fillOpacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_411_46116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1L142 1L82.3617 64.9599C79.1077 68.4498 77.4806 70.1947 75.5783 70.8424C73.9065 71.4115 72.0935 71.4115 70.4217 70.8424C68.5194 70.1947 66.8924 68.4498 63.6383 64.9599L4 1Z",
    fill: "#334155",
    fillOpacity: 0.1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_411_46116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1L137 1L77.4282 66.1567C75.0493 68.7585 70.9507 68.7585 68.5718 66.1567L9 1Z",
    fill: "#334155",
    fillOpacity: 0.05
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_411_46116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 0L143 0L77.0827 61.2089C74.7806 63.3466 71.2194 63.3466 68.9173 61.2089L3 0Z",
    fill: "#334155",
    fillOpacity: 0.1
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3L64.6546 56.3383C67.616 58.8797 69.0967 60.1504 70.7575 60.6339C72.2211 61.0601 73.7761 61.0592 75.2393 60.6314C76.8994 60.1459 78.3787 58.8736 81.3373 56.3288L144.5 2",
    stroke: "#475569",
    strokeOpacity: 0.06
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_411_46116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1L145 1L81.3523 55.8078C78.389 58.3595 76.9073 59.6354 75.2444 60.1214C73.7788 60.5498 72.2212 60.5498 70.7556 60.1214C69.0927 59.6354 67.611 58.3595 64.6477 55.8077L1 1Z",
    fill: "url(#paint3_linear_411_46116)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_411_46116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 144,
    height: 96,
    stroke: "url(#paint4_linear_411_46116)",
    strokeWidth: 16
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 143,
    height: 95,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.4
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1C32F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.193 25.1504C151.504 25.8249 150.731 26.401 149.894 26.8636L152.955 30.7542C153.061 30.888 153.214 30.9743 153.38 30.995C153.546 31.0156 153.714 30.9691 153.848 30.8651L155.039 29.9202C155.143 29.839 155.22 29.7273 155.261 29.5997C155.302 29.4721 155.305 29.3346 155.269 29.2053C155.247 29.1198 155.208 29.04 155.154 28.9711L152.193 25.1504Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.6 13.8695L145.63 13.8983L143.32 16.4495V10.8047C142.201 11.0949 141.165 11.6584 140.299 12.448V21.4165C141.136 22.2915 142.176 22.9295 143.32 23.2694V20.5948L144.042 19.5801L146.647 23.2776C147.607 22.8823 148.483 22.2945 149.223 21.548L146.099 17.5382L149.6 13.8695Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.804 7C142.396 7.00103 140.075 7.92863 138.292 9.60239C136.509 11.2762 135.391 13.5764 135.156 16.0559C134.921 18.5353 135.585 21.0167 137.019 23.0174C138.454 25.0182 140.556 26.3952 142.917 26.8808C145.279 27.3664 147.73 26.9258 149.795 25.6447C151.86 24.3636 153.39 22.3336 154.089 19.9494C154.787 17.5653 154.604 14.9974 153.575 12.7453C152.546 10.4931 150.744 8.71765 148.52 7.76415C147.342 7.25923 146.079 6.99956 144.804 7ZM144.804 24.5138C143.129 24.5158 141.506 23.9167 140.21 22.8186C138.914 21.7205 138.027 20.1914 137.699 18.4919C137.37 16.7924 137.622 15.0278 138.41 13.4987C139.199 11.9697 140.475 10.7709 142.022 10.1067C143.569 9.44249 145.29 9.35401 146.893 9.85634C148.496 10.3587 149.881 11.4207 150.811 12.8614C151.742 14.3021 152.162 16.0323 151.998 17.7571C151.834 19.4818 151.097 21.0944 149.913 22.32C148.558 23.7233 146.721 24.5124 144.804 24.5138Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_411_46116",
    x: 0,
    y: 33.7549,
    width: 146,
    height: 67.2451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_411_46116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_411_46116",
    x: 0,
    y: 20.9805,
    width: 146,
    height: 88.0195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_411_46116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_411_46116",
    x: -20,
    y: 2.73047,
    width: 186,
    height: 118.27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_411_46116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_411_46116",
    x: 1,
    y: 37.5566,
    width: 144,
    height: 59.4434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_411_46116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_411_46116",
    x: 0,
    y: -3,
    width: 146,
    height: 67.2451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_411_46116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_411_46116",
    x: 0,
    y: -11,
    width: 146,
    height: 88.0195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_411_46116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_411_46116",
    x: -20,
    y: -23,
    width: 186,
    height: 118.27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_411_46116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_411_46116",
    x: -1,
    y: -9,
    width: 148,
    height: 87.1084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_411_46116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_411_46116",
    x: -1,
    y: -4,
    width: 148,
    height: 70.8125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_411_46116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_411_46116",
    x: 1,
    y: 1,
    width: 144,
    height: 59.4424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_411_46116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_411_46116",
    x: -15,
    y: -15,
    width: 176,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_411_46116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_411_46116",
    x1: 72,
    y1: 0,
    x2: 72,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#EEF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848958,
    stopColor: "#F9FAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_411_46116",
    x1: 72,
    y1: 0,
    x2: 72,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475569",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475569",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_411_46116",
    x1: 73,
    y1: 34.9998,
    x2: 73,
    y2: 96.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.524194,
    stopColor: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_411_46116",
    x1: 73,
    y1: 1,
    x2: 73,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_411_46116",
    x1: 73,
    y1: 1.89719,
    x2: 73,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693396,
    stopColor: "#EEF0F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelop);
export default __webpack_public_path__ + "static/media/icon-envelop.bc23b5f05e72215ef09e5b23bc9aee1b.svg";
export { ForwardRef as ReactComponent };